/*
 * @Author: your name
 * @Date: 2020-12-05 10:53:32
 * @LastEditTime: 2020-12-26 15:22:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \gsly-bbb\src\assets\js\enumeration.js
 */
export default function () {
    return {
        // 预存款业务类型
        depositType: {
            10: '用户充值',
            11: '平台充值',
            12: '订单退款',
            20: '订单支付',
            21: '用户提现',
            22: '平台扣除',
        },
        ORDERPAYSTATE: {
            10: '支付宝扫码',
            20: '支付宝APP',
            25: '支付宝支付',
            30: '微信扫码',
            40: '微信公众号',
            50: '微信APP支付',
            60: '微信小程序支付',
            65: '微信支付',
            70: '银联PC',
            80: '银联移动',
            90: '线下支付',
            95: '授信支付',
            96: '预存款支付',
            97: '积分支付',
            100: '企业网银支付',
        },
        checkState: {
            10: '待审核',
            15: '审核中',
            20: '审核通过',
            30: '审核拒绝',
        },
        rightState: {
            10:'待审核',
            20:'待退款',
            21:'待退货',
            30:'待收货',
            70:'处理中',
            90:'已取消',
            91:'审核驳回',
            99:'已完成',
        },
        //店铺类型
        shopType: {
            10: '品牌旗舰店',
            20: '品牌专卖店',
            30: '类目专营店',
            40: '运营商自营',
            50: '多品类通用型',
        },
        //是否
        isTrue: {
            10: '是',
            20: '否',
        },
        //用户类型
        userType: {
            10: '零售会员',
            20: '终端客户',
            21: '代理商',
        },
        //售后类型
        rightsType: {
            10: '换货',
            20: '退款',
            30: '退货退款',
            40: '取消订单',
            // 50: '返场维修',
        },
        //状态
        state: {
            10: '申请',
            20: '驳回',
            21: '等待用户退货',
            30: '通过',
            40: '已退货',
            50: '收到退货',
            60: '等待退款',
            70: '退款完成',
            80: '等待发货,',
            90: '已发货',
            91: '确认收货',
            95: '用户取消',
            96: '投诉完成',
            99: '完成',
        },
        invoiceStatus: {
            10: '未申请',
            11: '不可申请',
            20: '待开票',
            21: '已申请',
            22: '已驳回',
            25: '已开票',
            30: '已邮寄',
            40: '已完成',
        },
        //取件方式
        returnType: {
            10: '自行寄回',
            20: '上门取件',
            30: '无需操作',
        },
        //申请售后原因
        rightsReasonType: {
            10: '质量问题',
            20: '7天无理由',
            30: '地址信息填写错误',
            40: '不想要了',
            50: '价格有点贵',
            60: '商品错选',
            70: '商品无货',
            80: '其他',
        },
        rightsTypeToDictCode: { // 退货类型转字典类型
            30:'40003',
            10:'40004',
            50:'40005',
            60:'40006',
            70:'40007',
            80:'40008',
            40:'40009'
        },
        // 投诉类型
        complaintType: {
            10: '商品问题',
            20: '配送问题',
            30: '支付问题',
            40: '促销活动问题',
            50: '账户问题',
            60: '发票问题',
            70: '系统问题',
            80: '退货/换货问题',
            90: '表扬/投诉工作人员',
            100: '其他',
        },
        //处理状态
        handleState: {
            10: '等待处理',
            20: '投诉成功',
            30: '关闭投诉',
            40: '买家撤销了投诉',
        },
        // 积分来源
        integralsSources: {
            10: '平台添加',
            20: '订单-下单',
            21: '订单-退款',
            22: '订单-赠送积分',
            23: '订单-退还积分',
            30: '兑换优惠券',
            40: '注册赠送',
            41: '生日赠送',
            90: '积分失效',
        },
        // 优惠券类型
        couponType: {
            10: '平台购物卷',
            20: '商家优惠卷',
        },
        //取消原因类型
        cancelType: {
            10: '地址填写错误',
            20: '不想要了',
            30: '价格有点贵',
            40: '商品错选或多项',
            50: '商品无货',
            60: '其它',
        },
        reviewState: {
            10: '待审核',
            20: '审核通过',
            30: '审核拒绝',
        },
        orderState: {
            5: '待审核',
            6: '平台审核',
            10: '待支付',
            15: '支付审核中',
            20: '待发货',
            25: '待发货-仓库拣货',
            29: '部分发货',
            30: '待收货',
            40: '已完成',
            41: '待开票',
            47: '取消订单-申请中',
            48: '取消订单-申请中',
            49: '取消订单-退款中',
            50: '已取消',
        },
        //支付状态
        payOrderState: {
            0: '待确认',
            10: '待支付',
            15: '待审核',
            20: '待确认',
            30: '驳回',
            40: '已支付',
        },
        //支付方式
        payState: {
            10: '支付宝扫码',
            20: '支付宝APP',
            25: '支付宝支付',
            30: '微信扫码',
            40: '微信公众号',
            50: '微信APP支付',
            60: '微信小程序支付',
            65: '微信支付',
            70: '银联PC',
            80: '银联移动',
            90: '线下支付',
            95: '授信支付',
            96: '预存款支付',
            97: '积分支付',
            100: '企业网银支付',
        },
        // 订单类型
        tradeType: {
            10: '标准订单',
            20: '赠送订单',
            30: '定制订单',
            40: '积分订单',
        },
        // 询价单状态
        inquiryState: {
            10: '待报价',
            20: '已报价',
            30: '已转订单',
            50: '已取消',
            40: '已失效',
        },
        // 采购单审核状态
        purchaseState: {
            10: '未申请',
            11: '未审批',
            15: '审批中',
            20: '审批通过',
            30: '已驳回',
            40: '已撤回',
            50: '审批超时',
        },
        costState: {
            1: '启用',
            0: '禁用'
        }
    }
}
